import { useContext, useMemo } from "react";
import { Autocomplete, TextField, Box } from "@mui/material";
import { MessengerContext } from "../../../contexts/MessengerContext";

const TemplateSelect = ({ showCustom }) => {
  const { templates, templateId, setTemplateId } = useContext(MessengerContext);

  const options = useMemo(() => {
    const base = templates || [];
    if (!showCustom) return base;
    return [{ _id: "custom", name: "Custom" }, ...base];
  }, [templates, showCustom]);

  const value = options.find((opt) => opt._id === templateId) || null;

  return (
    <Autocomplete
      size="small"
      options={options}
      value={value}
      getOptionLabel={(option) => option?.name || ""}
      isOptionEqualToValue={(option, value) =>
        option._id === value._id
      }
      onChange={(_, newValue) => {
        setTemplateId(newValue?._id || null);
      }}
      renderOption={(props, option) => (
        <Box
          component="li"
          {...props}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          {option.name}
        </Box>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Template"
          placeholder="Search templates…"
        />
      )}
      sx={{ width: 300 }}
    />
  );
};

export default TemplateSelect;
